import { render, staticRenderFns } from "./install.vue?vue&type=template&id=a151c934&scoped=true&"
import script from "./install.vue?vue&type=script&lang=js&"
export * from "./install.vue?vue&type=script&lang=js&"
import style0 from "./install.vue?vue&type=style&index=0&id=a151c934&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a151c934",
  null
  
)

export default component.exports